import { render, staticRenderFns } from "./FooterLogin.vue?vue&type=template&id=4f1d061a&scoped=true&"
var script = {}
import style0 from "./FooterLogin.vue?vue&type=style&index=0&id=4f1d061a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d061a",
  null
  
)

export default component.exports